module.exports = __webpack_public_path__ + "img/rejectedOrange.32c59e54.png";